import JobPostCard from "../Previews/JobPostCard/Preview";
import ShipBannerPreview from "../Previews/Ship/Banner/Preview";

export const CareerPages = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 1,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
        },
      ],
      preview: (activetab, cardData) => (
        <ShipBannerPreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 2,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },


        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

        {
          title: "English PDF",
          key: "english_file",
          className: "col-lg-3",
          type: "file",
          placeholder: "Upload English PDF",
          filetype: "pdf",
        },
        {
          title: "Simplified Chinese PDF",
          key: "simplified_chinese_file",
          className: "col-lg-3",
          placeholder: "Upload Simplified Chinese PDF ",
          type: "file",
          filetype: "pdf",
        },
        {
          title: "Traditional Chinese PDF",
          key: "traditional_chinese_file",
          className: "col-lg-3",
          placeholder: "Upload Traditional Chinese PDF ",
          type: "file",
          filetype: "pdf",
        },
        {
          title: "Bahasa PDF",
          key: "bahasa_file",
          className: "col-lg-3",
          placeholder: "Upload Bahasa PDF",
          type: "file",
          filetype: "pdf",
        },

      ],
      level1: [
        {
          title: "Job Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Job Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "Posting Date",
          key: "Date",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Job Simplified Chinese Posting Date",
          key: "simplified_chinese_date",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Posting Date",
          key: "traditional_chinese_date",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Posting Date",
          key: "bahasa_date",
          className: "col-lg-3",
          type: "input",
          required: false,
        },


        {
          title: "Job location",
          key: "location",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Job Simplified Chinese Location",
          key: "simplified_chinese_location",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese location",
          key: "traditional_chinese_location",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa location",
          key: "bahasa_location",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English highlights",
          key: "highlights",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese highlights",
          key: "simplified_chinese_highlights",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese highlights",
          key: "traditional_chinese_highlights",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa highlights",
          key: "bahasa_highlights",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

        {
          title: "English responsibilities",
          key: "responsibilities",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese responsibilities",
          key: "simplified_chinese_responsibilities",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese responsibilities",
          key: "traditional_chinese_responsibilities",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa responsibilities",
          key: "bahasa_responsibilities",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

        {
          title: "English qualifications",
          key: "qualifications",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese qualifications",
          key: "simplified_chinese_qualifications",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese qualifications",
          key: "traditional_chinese_qualifications",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa qualifications",
          key: "bahasa_qualifications",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

        {
          title: "English note",
          key: "note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese note",
          key: "simplified_chinese_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese note",
          key: "traditional_chinese_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa note",
          key: "bahasa_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

      ],
      preview: (activetab, cardData) => (
        <JobPostCard activetab={activetab} cardData={cardData} />
      ),
    },
  ],
};
